export default __webpack_public_path__ + "static/media/spotify.d396a4d6.png";